import { render, staticRenderFns } from "./CreateReportincompleted.vue?vue&type=template&id=be622780&"
import script from "./CreateReportincompleted.vue?vue&type=script&lang=js&"
export * from "./CreateReportincompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports